const makeContextError = (info) => new Error(`Recaptcha context not injected. ${info}`);
var makeContextError_default = makeContextError;
export {
  makeContextError_default as default
};
